import { Control, Controller } from "react-hook-form";
import {Checkbox, FormControlLabel, FormHelperText, Stack} from "@mui/material";
import {CheckboxProps} from "@mui/material/Checkbox/Checkbox";
import React from "react";

export interface ControlledCheckBoxProps extends CheckboxProps {
    label?: string | React.ReactNode,
    name: string,
    control: Control<any>
    disabled?: boolean,
}

export const ControlledCheckBox = (props: ControlledCheckBoxProps) => (
    <Controller
        control={props.control}
        name={props.name || ''}
        render={({field: {onChange, value}, fieldState: {error}}) => (
            <Stack direction="column">
                <FormControlLabel 
                    label={props.label ?? ''} 
                    disabled={props.disabled} 
                    control={
                        <Checkbox
                            {...props}
                            checked={value}
                            onChange={onChange}
                        />
                    }
                />
                
                { 
                    error && 
                        <FormHelperText error>
                            {error.message}
                        </FormHelperText>
                }
            </Stack>
        )}
    />
);